/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/10/17
 * Copyright All Rights Reserved
 */

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SignOutLink from 'components/SignOutLink';

/**
 * Wraps a SignOutLink with routing functionality
 */
const SignOutLinkWithRouter = withRouter(SignOutLink);

/**
 * Wraps a SignOutLinkWithRouter with access to the Redux Store
 */
export default connect()(SignOutLinkWithRouter);
